import {
  Grid,
  Tooltip,
  Button,
  Snackbar,
  Alert,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
  Box,
  Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import ingressService from "../../../services/ingressService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as styles from "./styles";
import { formatDateString } from "../../../helpers";
import CustomModal from "../../../components/customModal";
import { Link } from "react-router-dom";
import ModalListadoIngresos from "./modalListadoIngresos";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import autoTable from "jspdf-autotable";
import { jsPDF } from "jspdf";
import FilterModal from "../../../components/MFilters/index.js";
import { TextField } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import LogoPdf from "../../../../src/assets/LogoPdf.png";
import LabelPrinter from "../createIngress/labelPrinter.js";
import AuthService from "../../../services/authService.js";
import userService from "../../../services/userService.js";
import TablaGenerica from "../../../components/Table/tablaGenerica.js";
import CancelIcon from '@mui/icons-material/Cancel';
import { warehouseRemitenteLines } from "../../../utils/remitente";

// Los movimientos se guardan con date_created en UTC (now() del server) y el
// backend compara los rangos como datetime plano (sin timezone). Por eso el
// filtro from/to debe calcularse en UTC: con hora local de un huso detrás de
// UTC (ej. UTC-3) el límite superior quedaba antes del date_created UTC y los
// ingresos recién creados "desaparecían" de la lista.
const formatDate = (date) => {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const initialAlert = {
  severity: "success",
  message: "",
};

const ListadoIngresos = () => {
  const [incomeList, setIncomeList] = useState([]);
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [ingressDetail, setIngressDetail] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [alertObj, setAlertObj] = useState(initialAlert);
  const [buscandoIngresos, setBuscandoIngresos] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const currentDate = new Date();
  const oneMonthBefore = new Date();
  const [selectedProductsForLabels, setSelectedProductsForLabels] =
    useState(null);
  const hasCreatePermission = AuthService.hasPermission(
    "create",
    "movement_in"
  );
  const [deposits, setDeposits] = useState([]);
  const [selectedDepositName, setSelectedDepositName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [selectedIngressId, setSelectedIngressId] = useState(null);

  oneMonthBefore.setMonth(currentDate.getMonth() - 6);
  // Límite superior = fin del día UTC de hoy, para incluir cualquier ingreso
  // creado hoy sin depender de la hora exacta ni de un posible skew de reloj.
  currentDate.setUTCHours(23, 59, 59, 999);

  const [filters, setFilters] = useState({
    from: formatDate(oneMonthBefore),
    to: formatDate(currentDate),
    type: "in",
  });

  const statusOptions = {
    pending: "Pendiente",
    accepted: "Aceptado",
    cancelled: "Cancelado",
  };

  const [paginacion, setPaginacion] = useState({
    page: 1,
    page_size: 10,
    total: 0,
  });

  const fetchAllIngress = async (page, page_size) => {
    setIncomeList([]);
    setBuscandoIngresos(true);
    try {
      const result = await ingressService.getAllIngress({
        ...filters,
        page,
        page_size,
      });

      const { paging, results } = result.data;

      const sortedResults = results.sort(
        (a, b) => new Date(b.date_created) - new Date(a.date_created)
      );

      setIncomeList(sortedResults);

      setPaginacion((prev) => ({
        ...prev,
        page: paging.page,
        page_size: paging.page_size,
        total: paging.total,
      }));
    } catch (error) {
      setIncomeList([]);
    } finally {
      setBuscandoIngresos(false);
    }
  };

  useEffect(() => {
    getDeposit();
    fetchAllIngress(paginacion.page, paginacion.page_size);
  }, [filters]);

  const handleOpenFilterModal = (event) => setAnchorEl(event.currentTarget);
  const handleCloseFilterModal = () => setAnchorEl(null);
  const handleFilterApply = (newFilters) => setFilters(newFilters);

  const getColumns = () => {
    // Procesar (confirmar) = update; Cancelar = delete (acción destructiva).
    const hasUpdatePermission = AuthService.hasPermission(
      "update",
      "movement_in"
    );
    const hasReadPermission = AuthService.hasPermission("read", "movement_in");
    const hasDeletePermission = AuthService.hasPermission(
      "delete",
      "movement_in"
    );

    return [
      {
        title: "Fecha de Creacion",
        field: "date_created",
        sorting: false,
        render: (rowData) => {
          const fullDate = formatDateString(rowData["date_created"]);
          const [date, time] = fullDate.split(" ");

          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span>{date}</span>
              <span style={{ fontSize: "0.75em", color: "#666" }}>{time}</span>
            </div>
          );
        },
      },
      {
        title: "N° Orden",
        field: "id",
        maxWidth: 100,
        sorting: false,
        render: (rowData) => (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: "#2563EB",
              fontSize: "0.85rem",
            }}
          >
            #{rowData.id}
          </Typography>
        ),
      },
      {
        title: "Proveedor",
        field: "provider_name",
        sorting: false,
        render: (row) => (
          <Typography variant="body2" sx={{ fontWeight: 500, textAlign: "left" }}>
            {row.provider_name}
          </Typography>
        ),
      },
      {
        title: "Comprobante",
        field: "receipt_id",
        maxWidth: 110,
        sorting: false,
        render: (rowData) => (
          <Typography variant="body2" sx={{ color: "#555", fontSize: "0.85rem" }}>
            {rowData.receipt_id || "—"}
          </Typography>
        ),
      },
      {
        title: "Estado",
        field: "status",
        maxWidth: 130,
        sorting: false,
        render: (rowData) => {
          const statusColors = {
            pending: { bg: "#fff3e0", color: "#e65100", label: "Pendiente" },
            accepted: { bg: "#e8f5e9", color: "#2e7d32", label: "Aceptado" },
            cancelled: { bg: "#ffebee", color: "#c62828", label: "Cancelado" },
          };
          const s = statusColors[rowData.status] || { bg: "#f5f5f5", color: "#616161", label: rowData.status };
          return (
            <Chip
              label={s.label}
              size="small"
              sx={{
                backgroundColor: s.bg,
                color: s.color,
                fontWeight: 600,
                fontSize: "0.75rem",
                borderRadius: "6px",
              }}
            />
          );
        },
      },
      {
        title: "Artículos",
        field: "movement_details",
        sorting: false,
        render: (rowData) => {
          const totalSku = rowData.movement_details.length;
          const receivedSku = rowData.movement_details.filter((d) => d.effective_count).length;
          const totalUnits = rowData.movement_details.reduce((t, d) => t + d.original_count, 0);
          const receivedUnits = rowData.movement_details.reduce((t, d) => t + d.effective_count, 0);
          return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
              <Typography variant="caption" sx={{ color: "#555", fontWeight: 500 }}>
                SKU: <strong>{receivedSku}</strong>/{totalSku}
              </Typography>
              <Typography variant="caption" sx={{ color: "#555", fontWeight: 500 }}>
                Uds: <strong>{receivedUnits}</strong>/{totalUnits}
              </Typography>
            </Box>
          );
        },
      },
      {
        title: "Acciones",
        field: "acciones",
        sorting: false,
        render: (rowData) => (
          <Box sx={{ display: "flex", justifyContent: "center", gap: 0.5 }}>
            {rowData.status === "pending" && hasUpdatePermission && (
                <Tooltip title="Confirmar ingreso" arrow>
                  <Box
                    component="span"
                    onClick={() => handleOpenDetailModal(rowData.id, true)}
                    sx={{
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 32,
                      height: 32,
                      borderRadius: "8px",
                      transition: "background-color 0.2s",
                      "&:hover": { backgroundColor: "#e8f5e9" },
                    }}
                  >
                    <EditIcon sx={{ fontSize: 20, color: "#2e7d32" }} />
                  </Box>
                </Tooltip>
              )}

            {hasReadPermission && (
              <Tooltip title="Ver detalle" arrow>
                <Box
                  component="span"
                  onClick={() => handleOpenDetailModal(rowData.id, false)}
                  sx={{
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    transition: "background-color 0.2s",
                    "&:hover": { backgroundColor: "#E8F0FE" },
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: 20, color: "#2563EB" }} />
                </Box>
              </Tooltip>
            )}

            {rowData.status === "pending" && hasDeletePermission && (
                <Tooltip title="Cancelar ingreso" arrow>
                  <Box
                    component="span"
                    onClick={() => handleCancelEntry(rowData.id)}
                    sx={{
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 32,
                      height: 32,
                      borderRadius: "8px",
                      transition: "background-color 0.2s",
                      "&:hover": { backgroundColor: "#ffebee" },
                    }}
                  >
                    <CancelIcon sx={{ fontSize: 20, color: "#c62828" }} />
                  </Box>
                </Tooltip>
              )}
          </Box>
        ),
      },
    ];
  };

  const handleDownloadPDF = async () => {
    const doc = new jsPDF();

    const optimizedLogo = await optimizeImage(LogoPdf, {
      maxWidth: 300,
      maxHeight: 240,
      quality: 0.8,
    });

    doc.setFont("Helvetica");

    const logoWidth = 25;
    const logoHeight = 20;
    doc.addImage(
      optimizedLogo,
      "PNG",
      170,
      10,
      logoWidth,
      logoHeight,
      undefined,
      "FAST"
    );

    doc.setFontSize(20);
    doc.setFont("Helvetica", "bold");
    doc.text("DETALLE DE INGRESO", 105, 20, { align: "center" });

    let verticalSpace = 55;

    doc.setFontSize(12);
    doc.setFont("Helvetica", "normal");
    // Encabezado = depósito (configurable en /profile).
    const remitenteLines = warehouseRemitenteLines(ingressDetail);
    let headerY = 30;
    (remitenteLines.length ? remitenteLines : [""]).slice(0, 3).forEach((ln) => {
      doc.text(ln, 105, headerY, { align: "center" });
      headerY += 5;
    });

    doc.line(15, 45, 195, 45);

    doc.setFontSize(10);

    doc.setFont("Helvetica", "bold");
    doc.text("Información del ingreso", 20, verticalSpace);

    doc.setFont("Helvetica", "normal");
    verticalSpace += 8;

    doc.text(
      `Fecha de Creación: ${formatDateString(ingressDetail.date_created)}`,
      20,
      verticalSpace
    );
    doc.text(`Id Orden: ${ingressDetail.id}`, 110, verticalSpace);

    verticalSpace += 5;
    doc.text(`Proveedor: ${ingressDetail.provider_name}`, 20, verticalSpace);

    verticalSpace += 5;
    doc.text(`Comprobante: ${ingressDetail.receipt_id}`, 20, verticalSpace);
    doc.text(`Depósito: ${selectedDepositName}`, 110, verticalSpace);

    verticalSpace += 5;

    doc.text("Observaciones:", 20, verticalSpace);

    verticalSpace += 5;

    if (ingressDetail.observation) {
      const maxWidth = 75;
      const observationLines = doc.splitTextToSize(
        ingressDetail.observation,
        maxWidth
      );
      doc.text(observationLines, 20, verticalSpace);

      verticalSpace += observationLines.length * 4;
    } else {
      doc.text("Sin observaciones", 20, verticalSpace);
      verticalSpace += 4;
    }

    verticalSpace += 6;
    doc.line(15, verticalSpace, 195, verticalSpace);

    verticalSpace += 10;
    const data = ingressDetail.movement_details.map((producto) => [
      producto.sku_id,
      producto.description,
      producto.original_count.toString(),
      producto.effective_count === 0
        ? ""
        : producto.effective_count?.toString(),
    ]);

    autoTable(doc, {
      startY: verticalSpace,
      head: [
        ["SKU", "Descripción", "Cantidad declarada", "Cantidad ingresada"],
      ],
      body: data,
      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 90 },
        2: { cellWidth: 25 },
        3: { cellWidth: 25 },
      },
      styles: {
        overflow: "linebreak",
        halign: "center",
        valign: "middle",
      },
    });

    verticalSpace = doc.lastAutoTable.finalY + 10;

    doc.setFont("Helvetica", "bold");
    const totalSKU = ingressDetail.movement_details.length;
    const completedSKU = ingressDetail.movement_details.some(
      (detail) => detail.effective_count
    )
      ? totalSKU
      : 0;

    const totalUnidadesIngresadas = ingressDetail.movement_details.reduce(
      (total, detail) => total + (detail.effective_count || 0),
      0
    );

    const totalUnidadesOriginales = ingressDetail.movement_details.reduce(
      (total, detail) => total + (detail.original_count || 0),
      0
    );

    doc.text(
      `Total de productos: ${totalSKU} / ${completedSKU}`,
      20,
      verticalSpace
    );
    verticalSpace += 5;
    doc.text(
      `Total de unidades: ${totalUnidadesOriginales} / ${totalUnidadesIngresadas}`,
      20,
      verticalSpace
    );

    doc.save(`Detalle_ingreso_${ingressDetail.id}.pdf`);
  };

  const optimizeImage = (imageSource, options = {}) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");

        let width = img.width;
        let height = img.height;

        if (options.maxWidth && width > options.maxWidth) {
          height = (options.maxWidth * height) / width;
          width = options.maxWidth;
        }

        if (options.maxHeight && height > options.maxHeight) {
          width = (options.maxHeight * width) / height;
          height = options.maxHeight;
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        resolve(canvas.toDataURL("image/png", options.quality || 0.8));
      };
      img.src = imageSource;
    });
  };

  const handlePrintComplete = () => {
    setSelectedProductsForLabels([]);
  };

  const handleOpenDetailModal = async (id, isConfirm) => {
    setLoading(true);
    setOpenDetailModal(true);
    const result = await ingressService.getIngressById(id);
    const warehouseId = result.data.warehouse_id;
    const matchingDeposit = deposits.find(
      (deposit) => deposit.id === warehouseId
    );
    setSelectedDepositName(matchingDeposit.name);
    setIngressDetail(result.data);
    setIsEdit(isConfirm);
    setLoading(false);
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const handleStatusChange = (event, newValue) => {
    setSelectedStatus(newValue);
    setFilters({ ...filters, status: newValue });
  };

  const handleCloseDetailModal = () => setOpenDetailModal(false);

  const handleConfirmSuccess = (selectedProducts) => {
    console.log(selectedProducts);

    setSelectedProductsForLabels(selectedProducts);
  };

  const getDeposit = async () => {
    const result = await userService.getDeposits();
    setDeposits(result.data);
    console.log(result.data);
  };

  const handleCancelEntry = (id) => {
    setSelectedIngressId(id);
    setOpenCancelModal(true);
  };

  const handleCloseCancelModal = () => {
    setOpenCancelModal(false);
    setSelectedIngressId(null);
  };

  const handleConfirmCancel = async () => {
    try {
      await ingressService.cancelIngress(selectedIngressId);

      setAlertObj({
        severity: "success",
        message: "Ingreso cancelado exitosamente",
      });
      setOpenSnack(true);
      fetchAllIngress(paginacion.page, paginacion.page_size);
    } catch (error) {
      setAlertObj({
        severity: "error",
        message: "Error al cancelar el ingreso",
      });
      setOpenSnack(true);
    } finally {
      handleCloseCancelModal();
    }
  };

  return (
    <Grid container padding={5}>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: "#1a1a1a",
            pl: 1.5,
            borderLeft: (theme) => `4px solid ${theme.palette.secondary.main}`,
            lineHeight: 1.5,
          }}
        >
          Todos los ingresos
        </Typography>
        {hasCreatePermission && (
          <Link to="/create-ingress" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 3 }}
            >
              Crear ingreso
            </Button>
          </Link>
        )}
      </Box>

      <Paper
        elevation={0}
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          p: 1.5,
          mb: 2,
          borderRadius: "10px",
          border: "1px solid #e0e0e0",
          backgroundColor: "#fafafa",
        }}
      >
        <styles.StyledAutocomplete
          options={Object.keys(statusOptions)}
          getOptionLabel={(option) => statusOptions[option]}
          renderInput={(params) => <TextField {...params} label="Estado" />}
          value={selectedStatus}
          onChange={handleStatusChange}
        />
        <Tooltip title="Más filtros">
          <Button
            sx={{
              minWidth: "42px",
              width: "42px",
              height: "40px",
              borderRadius: "8px",
            }}
            variant="contained"
            color="primary"
            onClick={handleOpenFilterModal}
          >
            <FilterAltIcon />
          </Button>
        </Tooltip>
        <FilterModal
          anchorEl={anchorEl}
          onClose={handleCloseFilterModal}
          onFilter={handleFilterApply}
          initialFilters={filters}
        />
      </Paper>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          borderRadius: "12px",
          border: "1px solid #e0e0e0",
          overflow: "hidden",
        }}
      >
        <TablaGenerica
          data={incomeList}
          columns={getColumns()}
          loading={buscandoIngresos}
          emptyMessage={
            buscandoIngresos
              ? "Buscando ingresos..."
              : "No hay ingresos disponibles"
          }
          enablePagination={true}
          totalItems={paginacion.total || 0}
          currentPage={paginacion.page - 1 || 0}
          rowsPerPage={paginacion.page_size || 10}
          onPageChange={(event, newPage) => {
            setPaginacion((prev) => ({ ...prev, page: newPage + 1 }));
            fetchAllIngress(newPage + 1, paginacion.page_size);
          }}
          onRowsPerPageChange={(event) => {
            const newSize = parseInt(event.target.value, 10);
            setPaginacion((prev) => ({ ...prev, page_size: newSize, page: 1 }));
            fetchAllIngress(1, newSize);
          }}
          tableOptions={{
            sorting: false,
            search: true,
          }}
          tableStyle={{ width: "100%" }}
        />
      </Paper>
      <CustomModal
        open={openDetailModal}
        onClose={handleCloseDetailModal}
        title={isEdit ? "Confirmar ingreso" : "Detalle de Ingreso"}
        maxWidth="md"
      >
        <ModalListadoIngresos
          loading={loading}
          ingressDetail={ingressDetail}
          depositName={selectedDepositName}
          handleCloseDetailModal={handleCloseDetailModal}
          isEdit={isEdit}
          fetchAllIngress={() =>
            fetchAllIngress(paginacion.page, paginacion.page_size)
          }
          setAlertObj={setAlertObj}
          setOpenSnack={setOpenSnack}
          onConfirmSuccess={handleConfirmSuccess}
        />
        {!isEdit && !loading && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<DownloadIcon />}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                px: 3,
              }}
              onClick={handleDownloadPDF}
            >
              Descargar PDF
            </Button>
          </Box>
        )}
      </CustomModal>
      <Dialog
        open={openCancelModal}
        onClose={handleCloseCancelModal}
        aria-labelledby="cancel-dialog-title"
        aria-describedby="cancel-dialog-description"
        PaperProps={{ sx: { borderRadius: "12px", p: 1 } }}
      >
        <DialogTitle id="cancel-dialog-title" sx={{ fontWeight: 600 }}>
          Cancelar ingreso
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-dialog-description" sx={{ color: "#555" }}>
            ¿Estás seguro de que deseas cancelar este ingreso? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
          <Button
            onClick={handleCloseCancelModal}
            variant="outlined"
            sx={{ borderRadius: "8px", textTransform: "none" }}
          >
            Volver
          </Button>
          <Button
            onClick={handleConfirmCancel}
            color="error"
            variant="contained"
            sx={{ borderRadius: "8px", textTransform: "none" }}
          >
            Confirmar cancelación
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openSnack}
        autoHideDuration={3000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnack}
          severity={alertObj?.severity}
          sx={{ width: "100%" }}
        >
          {alertObj.message}
        </Alert>
      </Snackbar>
      {selectedProductsForLabels && selectedProductsForLabels.length > 0 && (
        <LabelPrinter
          selectedProducts={selectedProductsForLabels}
          onPrintComplete={handlePrintComplete}
        />
      )}
    </Grid>
  );
};

export default ListadoIngresos;
